import { render, staticRenderFns } from "./FooterMainPiedPro.vue?vue&type=template&id=9a583b48&"
import script from "./FooterMainPiedPro.vue?vue&type=script&lang=js&"
export * from "./FooterMainPiedPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports